import { render } from "./EmptyRooms.vue?vue&type=template&id=16f3583f&scoped=true"
import script from "./EmptyRooms.vue?vue&type=script&lang=js"
export * from "./EmptyRooms.vue?vue&type=script&lang=js"

import "./EmptyRooms.vue?vue&type=style&index=0&id=16f3583f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f3583f"]])

export default __exports__